import { render } from "./MyCarrer.vue?vue&type=template&id=615e58b2&scoped=true"
import script from "./MyCarrer.vue?vue&type=script&lang=js"
export * from "./MyCarrer.vue?vue&type=script&lang=js"

import "./MyCarrer.vue?vue&type=style&index=0&id=615e58b2&scoped=true&lang=scss"

import exportComponent from "/srv/http/cv.mzubiaga.net/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615e58b2"]])

export default __exports__